import React, { useEffect, useState } from 'react'
import { Button, Col, Form, FormControl, InputGroup, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDeleteAbRemoteStrategyMutation, useGetAbRemoteStrategyQuery, useUpdateAbRemoteStrategyMutation } from '../../api/abRemoteStrategyApiSlice';
import Block from '../Block';
import Icon from '../Icon';
import { Yup, useForm } from '../components';
import { NewRemoteParameter, RemoteParametersList } from './RemoteConfigurationShow';
import RemoteConfigurationHistory from './RemoteConfigurationHistory';
import { useGetConfigurableRemoteConfigurationQuery } from '../../api/remoteConfigurationApiSlice';

const ABRemoteStrategyForm = ({appId, abRemoteStrategy}) => {
  const { t } = useTranslation();
  const [update] = useUpdateAbRemoteStrategyMutation();
  const [delete_strategy] = useDeleteAbRemoteStrategyMutation();

  const initialValues = {
    app_id: appId,
    ratio: 0.0,
  };

  const validationSchema = Yup.object().shape({
    app_id: Yup.number().required(),
    ratio: Yup.number().required()
  })

  const { formData, setFormData, getInputProps, formProps, submitButtonProps } = useForm({
    defaultObject: abRemoteStrategy,
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: ()=>{ update(formData) },
  });

  const disableDelete = !abRemoteStrategy.groupes

  return <>
  <Form>
    <Form.Row className="align-items-center">
      <Col xs="8">
        <Form.Label htmlFor="percent" srOnly>
          {t(`app.remoteConfiguration.ABRatioTitle`)}
        </Form.Label>
        <InputGroup>
          <FormControl
            id="percent"
            value={100 * formData.ratio}
            onChange={(e)=>(setFormData({ ...formData, ratio: Number(e.target.value) / 100 }))}
            type='number'
            min={0}
            max={100}
            step={1}
            placeholder={t(`app.remoteConfiguration.ABRatioTitle`)} />
          <InputGroup.Append>
            <InputGroup.Text>%</InputGroup.Text>
          </InputGroup.Append>
        </InputGroup>
      </Col>
      <Col xs="4">
        <Button key="submit" variant="primary" onClick={()=>(update(formData))}>
          <Icon icon='save' text={t("save")} />
        </Button>
        <Button key="delete" variant="primary" disabled={disableDelete} onClick={()=>(delete_strategy(appId))}>
          <Icon icon='trash' text={t("delete")} />
        </Button>
      </Col>
    </Form.Row>
  </Form>
  </>
}

const AbGroupRemoteConfiguration = ({group, ratio}) => {
  const { t } = useTranslation()
  const { data, isLoading, isSuccess, isError } = useGetConfigurableRemoteConfigurationQuery(group)
  const [showModal, setShowModal] = useState(false)

  if ( isLoading ) { return (<></>) }
  const _ratio = group.condition ? ratio : 1 - ratio
  const percent = (_ratio).toLocaleString(undefined, { style: 'percent', maximumFractionDigits: 0 });

  return (<>
        <Row className="align-items-center">
          <Col>
          <h2>{data.configurable_name} <span>({percent})</span> </h2>
          </Col>
          <Col md="auto">
            <Button onClick={()=>setShowModal(true)}>
              <Icon icon='timeline' text={t("history")} />
            </Button>
          </Col>
        </Row>
        <RemoteParametersList configuration={data} />
        <NewRemoteParameter configuration={data}/>
        <RemoteConfigurationHistory show={showModal} onClose={()=>(setShowModal(false))} configurable={data}/>
  </>)
}

const AppABRemoteConfiguration = ({appId})=>{
  const { data: abRemoteStrategy={} } = useGetAbRemoteStrategyQuery(appId)  
  const { t } = useTranslation();
  const [showAB, setShowAB] = useState(false)
  const [showABCheck, setShowABCheck] = useState(true)

  useEffect(() => {
    if (abRemoteStrategy.groupes) {
      setShowAB(true)
      setShowABCheck(false)
    } else {
      setShowAB(false)
      setShowABCheck(true)
    }
  }, [abRemoteStrategy])
  

  return (
    <>
      { showABCheck &&
        <Form.Check
          type="checkbox"
          className="mb-2"
          checked={showAB}
          // onChange={()=>(setShowAB(e.target.check))}
          onChange={(e)=>(setShowAB(e.target.checked))}
          label={t(`app.remoteConfiguration.WithABGroup`)}
        />
      }
      { showAB &&
        <Block title={t(`app.remoteConfiguration.ABDeploy`)} style={{maxWidth: "700px"}}>
          <ABRemoteStrategyForm appId={appId} abRemoteStrategy={abRemoteStrategy} />
          { abRemoteStrategy.groupes && abRemoteStrategy.groupes.map((group)=>(
            <AbGroupRemoteConfiguration key={group.id} ratio={abRemoteStrategy.ratio} group={{...group, remote_configurable_id: group.id, remote_configurable_type: 'AbRemoteGroup'}}/>
          ))}
        </Block>
      }
    </>
  )
}

export default AppABRemoteConfiguration